{
  "account": {
    "title": "Min konto",
    "list": {
      "title": "Kontoer",
      "description": "Liste over fakturaer tilknyttet kontoer"
    },
    "form": {
      "name": {
        "title": "Navn",
        "description": "Ditt kontonavn"
      },
      "password": {
        "title": "Passord",
        "description": "Sett et nytt passord for kontoen din; la det stå tomt for å beholde gjeldende passord"
      },
      "emailPreferences": {
        "title": "E-postpreferanser",
        "description": "Velg typer e-postvarsler"
      }
    },
    "billing": "Faktureringsdetaljer",
    "subscriptions": "Abonnementer",
    "manageSubscription": "Administrer abonnement",
    "popup": {
      "cancel": "Er du sikker på at du vil avbryte abonnementet ditt?<br/>Nettstedet ditt vil fortsette å bli oversatt til slutten av gjeldende abonnementsperiode. Etter dette deaktiveres oversettelsen.<br/>Vennligst merk at du ikke vil ha rett til refusjon for ubrukt periode.",
      "downgrade": "Er du sikker på at du vil nedgradere? Nedgraderingen trer i kraft umiddelbart.<br/>Vennligst merk at du ikke vil ha rett til refusjon for gjenværende tid i gjeldende faktureringssyklus.<br/>Ny planpris vil gjelde fra neste faktureringssyklus.",
      "default": "Er du sikker på at du vil endre plan?",
      "resume": "Er du sikker på at du vil gjenoppta abonnementet ditt?"
    }
  },
  "ai_translation": {
    "header": "AI-oversettelse",
    "plan": {
      "header": "Prissetting for AI-oversettelse",
      "used": "Du har brukt {words_used} / {words_allowed} oversatte ord i AI-kredittene dine.",
      "remaining": "Tilgjengelige AI-kreditter:",
      "words": "ord",
      "add_more_credits": "Kjøp flere AI-kreditter",
      "details": {
        "idiomatic_expressions": "Idiomatiske og tekniske uttrykk",
        "background_translation": "Oversettelser i bakgrunnen",
        "best_website": "Nettsteder som krever perfekt oversettelseskvalitet",
        "page_context": "Side- og nettsteds kontekst for oversettelse",
        "perfect_quality": "Perfekt kvalitet, rimelig pris",
        "no_recurring": "Ingen gjentakende betaling, forhåndsbetalt kvote",
        "save_40": "Spar  % sammenlignet med 20 $-planen",
        "save_50": "Spar 50 % sammenlignet med 20 $-planen"
      },
      "quota": "{estimated_words} ord ~ {estimated_pages} sider"
    },
    "settings": {
      "banner": {
        "title": "Linguise AI-oversettelse",
        "intro": "Linguise lanserer nå Linguise AI-oversettelse, en ny premium-funksjon som bruker AI LLM-modeller (nyeste Llama-modeller, optimalisert for oversettelsesoppgaver). Utviklet for nettsteder som krever feilfri nøyaktighet, tar den hensyn til både side- og hele nettsteds kontekst for enestående resultater. Gi kundene dine topp kvalitet på oversettelser, og sørg for at budskapet deres resonnerer perfekt på alle språk.",
        "button": "Oppgrader nå"
      },
      "alert": {
        "description": "Denne funksjonen er ikke inkludert i din nåværende plan og krever separat kjøp.\nAktiver dette tillegget for å låse opp alle alternativene som er listet nedenfor."
      },
      "languages": {
        "title": "Bruk AI-oversettelse på språk",
        "description": "Velg spesifikke språk der du vil at AI-oversettelse skal gjelde"
      },
      "button": {
        "save": "Lagre innstillinger"
      },
      "form": {
        "advanced": {
          "title": "Avanserte AI-instruksjoner",
          "description": "Avanserte AI-instruksjoner"
        },
        "enable_mode": {
          "title": "AKTIVER AI-OVERTTELSE",
          "description": "Velg hvordan du vil aktivere AI-oversettelse.\nBare regler vil bruke følgende regler.\nBare live-editor vil tillate å aktivere oversettelse side for side fra live-editor-visning.\nRegler og live-editor vil bruke begge funksjonene.",
          "disabled": "Deaktivert",
          "rules": "Bare regler",
          "live_editor": "Bare live-editor",
          "all": "Regler og live-editor"
        },
        "rule_application": {
          "description": "Bruk AI-oversettelse på statisk innhold, dynamisk innhold eller begge",
          "title": "Bruk på innhold",
          "all": "Alt innhold",
          "static": "Statisk innhold",
          "dynamic": "Dynamisk innhold"
        },
        "website_topic": {
          "title": "Nettstedsemne",
          "placeholder": "Sushi-restaurant...",
          "description": "Definer emnet for nettstedet ditt for bedre oversettelseskvalitet (f.eks. rettslig, sushi-restaurant, sykkeldeler nettbutikk …)\nSkriv inn nettstedsemnet på engelsk."
        },
        "apply_to_urls": {
          "title": "Bruk på URL-er",
          "description": "Velg spesifikke URL-er der du vil at AI-oversettelse skal gjelde",
          "all_urls": "Alle URL-er",
          "selected_urls": "Utvalgte URL-er",
          "label": "URL å bruke på",
          "placeholder": "URL å bruke på",
          "wildcard": "Jokertegn",
          "regex": "Regulært uttrykk",
          "add": "Legg til ny",
          "expression": "Uttrykkstype"
        },
        "apply_languages": {
          "title": "Bruk på språk",
          "description": "Velg spesifikke språk der du vil at AI-oversettelse skal gjelde",
          "all_languages": "Alle språk",
          "selected_languages": "Utvalgte språk",
          "placeholder": "Velg språk...",
          "feedback": "Du må velge et språk"
        },
        "formality": {
          "title": "Formalitet",
          "description": "Angi graden av formalitet i oversettelser, muligens viktig for målgrupper og kontekster.\n«Nøytral» vil forsøke å beholde originalinnholdets formalitet.\n«Formell» er for profesjonelt, forretningsmessig eller rettslig innhold (dvs. bruk av formelle pronomen som «usted» på spansk).\n«Uformell» er for uformelt, konversasjonelt innhold (dvs. bruk av «tú» på spansk).",
          "neutral": "Nøytral",
          "formal": "Formell",
          "informal": "Uformell"
        },
        "sentence_structure": {
          "classic": "Klassisk",
          "short": "Korte og slagkraftige setninger",
          "detailed": "Detaljerte og forklarende setninger",
          "title": "Setningsstruktur",
          "description": "Definer preferanse for skrivestil."
        },
        "content_purpose": {
          "marketing": "Markedsføring/promotering (overbevisende, engasjerende tone)",
          "technical": "Teknisk/instruksjon (klar, presis, handlingsorientert)",
          "support": "Kundestøtte (empatisk, hjelpsom, beroligende)",
          "legal": "Rettslig/samsvar (presis, formell, utvetydig)",
          "educational": "Utdannende (klar, strukturert, tilgjengelig)",
          "other": "Annet (på engelsk)",
          "title": "Innholdets formål",
          "description": "Definer det funksjonelle formålet med innholdet som skal oversettes.",
          "other_placeholder": "Beskriv formålet..."
        },
        "target_audience": {
          "title": "Målgruppe",
          "description": "Angivelse av den tiltenkte målgruppen for det oversatte innholdet (på engelsk).",
          "placeholder": "f.eks. spansktalende foreldre, EUs personvernombud"
        },
        "override_default_translations": {
          "title": "Overstyr standardoversettelse",
          "description": "Hvis satt til JA, vil dette alternativet tvinge innholdet til å bli oversatt med AI (Linguise AI) selv om det allerede er oversatt av Cloud AI-oversettelse (standard oversettelsesmodell)."
        },
        "force_replace_before": {
          "title": "Tving ny oversettelse med KI",
          "description": "Oversett på nytt med KI alt innhold der KI-oversettelsen ble laget før den valgte datoen, for eksempel innhold oversatt med en eldre modell. Ny oversettelse skjer ved neste besøk på aktuelle sider i henhold til reglene og bruker KI-kredittene dine.",
          "before_date": "Før en dato"
        },
        "model": {
          "current": "Gjeldende",
          "title": "Modell",
          "description": "Velg LLM-oversettelsesmodellen du vil bruke",
          "load_error": "Kan ikke laste inn tilgjengelige modeller. Prøv igjen senere.",
          "thinking_warning": "Denne modellen bruker et høyt nivå av resonnement (\"tenkning\") og vil forbruke betydelig flere tokens per oversettelse."
        },
        "override_manual_and_selected": {
          "no_default": "Nei (standard)",
          "title": "Overstyr manuelle og valgte oversettelser",
          "description": "Som standard blir en oversettelse du har redigert manuelt alltid stående på nettstedet ditt, også etter at en AI-forbedret oversettelse er generert. Sett til JA for å vise den AI-forbedrede oversettelsen i stedet. De manuelle oversettelsene dine beholdes, og du kan bytte tilbake når som helst. Dette gjelder også når du oversetter sidene på nytt for å få nye oversettelser; den nyeste oversettelsen brukes automatisk."
        }
      },
      "message": {
        "save_success": "Av det nåværende allerede oversatte innholdet vil omtrent {{ai_affected_urls}} sider bli forbedret med AI-oversettelse.",
        "save_success_only": "Innstillinger lagret."
      }
    },
    "pricing": {
      "plan": {
        "title": "Bestill AI-oversettelseskvote",
        "buy_button": "KJØP AI-OVERTTELSESPAKKE"
      },
      "modal": {
        "title": "Bekreft endring av plan",
        "description": "Er du sikker på at du vil endre AI-oversettelsesplanen din?",
        "button_cancel": "Avbryt",
        "button_confirm": "Bekreft",
        "loading": "Vennligst vent...",
        "amount": "Beløp",
        "credit": "Kreditt",
        "total_due": "Totalt å betale"
      },
      "comparison": {
        "title": "Google Cloud AI-oversettelse\nvs Linguise AI-oversettelse",
        "list": {
          "0": {
            "google": "Raske og pålitelige oversettelser",
            "linguise": "Håndterer idiomatiske og tekniske uttrykk"
          },
          "1": {
            "google": "Øyeblikkelige oversettelser av alle nettsidene",
            "linguise": "Generering av oversettelser i bakgrunnen"
          },
          "2": {
            "google": "Beste kvalitet, lav pris",
            "linguise": "Perfekt kvalitet, rimelig pris"
          },
          "3": {
            "google": "Best egnet for store nettsteder eller lavt budsjett",
            "linguise": "Best for nettsteder som krever perfekt oversettelseskvalitet"
          },
          "4": {
            "google": "Sidekontekst for oversettelse",
            "linguise": "Side- og nettsteds­kontekst for oversettelse"
          }
        }
      },
      "botom_banner": {
        "title": "Opplev enestående oversettelses­nøyaktighet med",
        "sub_title": "Den nye Linguise AI-oversettelsen",
        "description": "Linguise forbedrer sine automatiske oversettelsestjenester med lanseringen av Linguise AI-oversettelse, et kraftig nytt alternativ som benytter banebrytende AI-oversettelses-LLM (nyeste Llama-modeller optimalisert for oversettelser). Denne tilleggstjenesten gir nettutviklere og nettbyråer en enda høyere oversettelseskvalitet, ideell for prosjekter der perfeksjon er avgjørende. Linguise AI-oversettelse utfyller vår eksisterende, høykvalitets Google Cloud AI-oversettelse og gir deg større fleksibilitet og presisjon."
      }
    },
    "success": {
      "tab_title": "Takk for kjøpet av AI-oversettelsesabonnementet!",
      "title": "Takk for kjøpet av AI-oversettelsesabonnementet!",
      "subtitle": "AI-oversettelsesabonnementet ditt er nå kjøpt!",
      "message": "Du kan administrere AI-oversettelsesabonnementet ditt på siden for AI-oversettelses­innstillinger.",
      "home": "Administrer AI-oversettelse"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Navn",
        "description": "Faktureringskontonavn"
      },
      "phone": {
        "title": "Telefon",
        "description": "Faktureringskontotelefon"
      },
      "email": {
        "title": "E-post",
        "description": "Faktureringskontoe-post"
      },
      "address": {
        "title": "Adresse",
        "description": "Faktureringskontoadresse",
        "city": "By",
        "country": "Land",
        "address1": "Adresse 1",
        "address2": "Adresse 2",
        "postal": "Postnummer",
        "state": "Fylke"
      },
      "tax": {
        "title": "Organisasjonsnummer"
      }
    }
  },
  "checkouts": {
    "header": "Kasse",
    "payment_method": "Velg betalingsmåte",
    "stripe_card": "Kredittkort (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Oppgi ny faktureringsadresse",
      "existing": "Bruk eksisterende adresse"
    },
    "pay_stripe": "Bekreft og betal",
    "terms": "Ved å bekrefte abonnementet ditt tillater du Linguise å belaste deg for fremtidige betalinger i samsvar med våre vilkår. Du kan når som helst avslutte abonnementet.",
    "coupon": {
      "title": "Har du en kupong?",
      "placeholder": "Sett inn kupongkoden din her",
      "apply": "Bruk",
      "percent": "{{0}} % rabatt"
    },
    "add_new": "Legg til ny",
    "use_existing": "Bruk eksisterende betalingsmåte",
    "recurring": {
      "month_single": "Faktureres månedlig",
      "month_many": "Faktureres hver {{count}}. måned",
      "year_single": "Faktureres årlig",
      "year_many": "Faktureres hvert {{count}}. år",
      "day_single": "Faktureres daglig",
      "day_many": "Faktureres hver {{count}}. dag",
      "week_single": "Faktureres ukentlig",
      "week_many": "Faktureres hver {{count}}. uke"
    },
    "add_new_no_stripe": "Legg til nytt kort",
    "summary": {
      "title": "Oppsummering",
      "subtotal": "Delsum",
      "total": "Totalt"
    }
  },
  "dashboard": {
    "main": {
      "title": "Kontrollpanel"
    },
    "statistics": {
      "main_title": "Statistikk siste 30 dager",
      "characters": "Oversatte tegn",
      "words": "Oversatte ord",
      "bandwidth": "Innkommende båndbredde",
      "request": "Forespørsler",
      "page_views": "Sidevisninger per språk (siste 30 dager)",
      "multilingual_views": "Flerspråklige sidevisninger (siste 30 dager)",
      "most_page_viewed": "20 mest viste sider (siste 30 dager)",
      "no_data_yet": "Ingen data tilgjengelig ennå",
      "th_language": "Språk",
      "th_page_views": "Sidevisninger",
      "real_visitors": "Ekte besøkende",
      "crawler": "Nettcrawler"
    },
    "planHints": {
      "subscribeButton": "Abonner",
      "upgradeButton": "Oppgrader",
      "usedWords": "Du bruker for øyeblikket {words_used} ord",
      "noPlan": "Ingen plan er aktivert for dette domenet. Abonner på en plan og begynn å oversette nettstedet ditt",
      "noPlanShopify": "Ingen plan er aktivert for dette domenet. Abonner på en plan fra Shopify-dashbordet ditt og begynn å oversette nettstedet ditt",
      "trialUsage": "Du bruker for øyeblikket {words_used} ord av {words_allowed} ord inkludert i prøveplanen.",
      "trialEnds": "Den første månedens prøveperiode er aktivert til {trial_ends}.",
      "subscribeMessage": "Abonner før den er slutt for å beholde oversettelsen av nettstedet ditt",
      "subscribeMessageShopify": "Abonner fra Shopify-dashbordet ditt før den er slutt for å beholde oversettelsen av nettstedet ditt",
      "trialReachedLimit": "Du har nådd maksimalt antall oversatte ord for prøveperioden.\nAbonner på en av våre planer for å fortsette å oversette nettstedet ditt.",
      "paidUsage": "Du har brukt {words_used} / {words_allowed} oversatte ord i planen din.",
      "paidReachedLimit": "Du har nådd maksimalt antall oversatte ord for gjeldende plan.\nOppgrader planen din for å fortsette å oversette innholdet på nettstedet ditt.",
      "trialOfferedUsage": "Du bruker for øyeblikket {words_used} ord av {words_allowed} ord inkludert i prøveplanen. (Inkludert {free_words} gratis ord)",
      "paidOfferedUsage": "Du har brukt {words_used} / {words_allowed} oversatte ord i planen din. (Inkludert {free_words} gratis ord)",
      "noPlanExtra": "Vær oppmerksom på at inaktive domener og deres data slettes jevnlig.",
      "planRecommended": "Basert på ditt nåværende oversettelsesvolum, er planen vi anbefaler:",
      "planMaximumWords": "{{words}} ord",
      "notHaveTranslatedWords": "Du har ikke gjort noen oversettelser ennå"
    },
    "translationSetup": {
      "kicker": "OPPSETT AV SUBDOMENE",
      "title": "Kontroller oversettelsesoppsett",
      "description": "Se gjennom DNS, oversatte verter, tilgang til det opprinnelige nettstedet og kontogrenser.",
      "starting": "Kontrollerer...",
      "button": "Kontroller oppsett",
      "viewLatest": "Vis siste resultat",
      "viewCurrent": "Vis gjeldende kontroll",
      "runAgain": "Kjør kontrollen på nytt",
      "viewDetails": "Vis detaljer",
      "hideDetails": "Skjul detaljer",
      "error": "Kan ikke kontrollere oppsettet",
      "allPassed": "Alle kontroller bestått",
      "setupNeedsAttention": "Oppsettet krever oppmerksomhet",
      "setupNeedsAttentionDescription": "Én eller flere kontroller mislyktes. Se gjennom punktene nedenfor eller kontakt Linguise-brukerstøtte.",
      "lastChecked": "Sist kontrollert {{time}}",
      "domainOwnership": "Domenetilhørighet",
      "domainOwnershipDescription": "Verifiseringsoppføring funnet",
      "domainOwnershipFailure": "DNS-oppføringen for domenetilhørighet kunne ikke verifiseres.",
      "translatedHosts": "Oversatte verter",
      "translatedHostsDescription": "{{count}} språkverter kontrollert",
      "translatedHostsFailure": "Én eller flere CNAME-oppføringer for språk er feil.",
      "subdomainPage": "Subdomene-side",
      "subdomainPageDescription": "{{count}} oversatte sider godtar HTTPS",
      "subdomainPageFailure": "TLS-tilkoblingen mislyktes da én eller flere oversatte sider ble åpnet.",
      "originalSite": "Opprinnelig nettsted",
      "originalSiteDescription": "Kontroller av DNS, TLS og svar fra det opprinnelige nettstedet",
      "originalSiteFailure": "Kontrollen av DNS, TLS eller svar fra det opprinnelige nettstedet mislyktes.",
      "documentationAdvice": {
        "dns": "Se gjennom DNS-oppsettet",
        "tls": "Se gjennom HTTPS-oppsettet",
        "origin": "Se gjennom oppsettet for det opprinnelige nettstedet",
        "diagnostic": "Se gjennom feilsøkingstrinnene"
      },
      "evidence": {
        "originDns": "Opprinnelig DNS",
        "originTls": "Opprinnelig TLS",
        "originHttp": "Opprinnelig svar",
        "observedTargets": "Observerte mål",
        "recordCount": "Oppføringer funnet",
        "addressCount": "Adresser funnet",
        "statusCode": "HTTP-status",
        "redirect": "Viderekobling",
        "expiresAt": "Sertifikatet utløper",
        "raw": "{{key}}",
        "noValue": "Ingen verdi"
      },
      "checkerError": "Noen kontroller kunne ikke fullføres.",
      "coreLocation": "Kontrollert fra {{location}}",
      "status": {
        "queued": "I kø",
        "running": "Kjører",
        "completed": "Fullført",
        "failed": "Mislyktes",
        "passed": "Bestått",
        "warning": "Advarsel",
        "unknown": "Ukjent",
        "skipped": "Hoppet over",
        "not_applicable": "Ikke aktuelt"
      }
    },
    "throttling": {
      "title": "Oversettelsesgrense",
      "description": "Midlertidige bruksgrenser",
      "unavailable": "Midlertidige oversettelsesgrenser er utilgjengelige",
      "window": "{{used}} / {{max}} ord",
      "resetsIn": "Tilbakestilles om {{time}}",
      "throttled": "Oversettelsen er midlertidig satt på pause",
      "throttledDescription": "En midlertidig bruksgrense er nådd. Oversettelsen fortsetter når denne perioden tilbakestilles."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "STEG {{step}} AV {{total}}",
      "doneLabel": "FERDIG, DU KAN BEGYNNE Å OVERSÈTTE!",
      "finish": {
        "title": "",
        "description": "Dette er API-nøkkelen du skal bruke på nettstedet ditt"
      },
      "instructions": "Installasjonsinstruksjon",
      "domainSetting": "Domenekonfigurasjon",
      "step": {
        "titleWordpress": "WordPress",
        "titleJoomla": "Joomla",
        "titlePHP": "PHP-skript",
        "wizardWordpressStep1": "1. Installer ",
        "wizardWordpressStep2": " 2. I plugin-innstillingene kopierer du og fyller inn API-nøkkelen din\n",
        "wizardWordpressStep3": "3. Du er klar til å oversette\n\n",
        "wizardWordpressStep4": "For en mer detaljert instruksjon, vennligst se vår dokumentasjon: ",
        "wizardJoomlaStep1": "1. Joomla-pakke-lenke: ",
        "wizardJoomlaStep2": "\n2. I utvidelseskonfigurasjonsinnstillingene kopierer og fyller du inn API-nøkkelen din",
        "wizardJoomlaStep3": "3. I modulkonfigurasjonen angir du språkene du ønsker å vise, og setter inn modulen der du trenger den.",
        "wizardJoomlaStep4": "\n 4. Du er klar til å oversette\n\n",
        "wizardPhpStep1": "1. Last ned vårt php-skript og her ",
        "wizardPhpStep2": "\n2. Følg installasjonsinstruksjonene på vår dokumentasjonsside her ",
        "wizardPhpStep3": "\n3. Legg til modulen på sidene dine.",
        "wizardPhpStep4": "\n Kopier følgende kode og legg den til i head på html-siden din, så vises brytermodulen automatisk\n",
        "dispatchStep1": "Vi har sendt de påkrevde dataene til Linguise-pluginen. Du kan nå lukke det følgende vinduet.",
        "dispatchStep2": "I tilfelle token mangler når du lukker dette vinduet, vennligst kopier følgende token:",
        "dispatchStep3": "Du kan også kopiere dette utdraget for å automatisk aktivere vår flaggbryter",
        "wizardOtherStep1": "Følg instruksjonene nedenfor for å installere Linguise på ditt domene.\n",
        "wizardOtherStep2": "Kopier følgende kode og legg den til i head på html-siden din, så vises brytermodulen automatisk.\n"
      },
      "trialAlreadyUsed": "Det ser ut som du allerede har brukt din gratis prøveperiode, så du må skaffe oversettelseskvote\nVennligst abonner på en plan eller kontakt oss hvis du trenger å forlenge prøveperioden din.",
      "usefulLinks": "Nyttige lenker for å komme i gang",
      "linkDocumentation": "Dokumentasjon",
      "linkExtensionDl": "Nedlasting av utvidelse",
      "linkSubscribe": "Abonner på en plan nå",
      "linkDashboard": "Gå til kontrollpanelet",
      "exclusion": {
        "title": "Bedrifts- og produktnavn",
        "description": ""
      },
      "finishButton": "Fullfør oppsettet",
      "subdomains": "Underdomener",
      "subdomain_setup": "Sett opp domene",
      "subdomain_auto_setup": "Koble til DNS-en din automatisk",
      "subdomain_manual_setup": "Legg til DNS-poster selv",
      "subdomain_skip": "Gjør det senere",
      "auto_subdomains_info": "Din nettstedbygger CMS krever en DNS-konfigurasjon for å sette språk per underdomene (f.eks. es.domene.com).",
      "auto_subdomains_info_2": "Du kan gjøre det automatisk ved hjelp av Entri. Bare klikk på \"Koble til DNS-en din automatisk\"-knappen for å begynne å koble til DNS-administratoren din og legg dem til med Entri.",
      "auto_subdomains_info_manual": "Eller du kan konfigurere domenet ditt manuelt ved å klikke på \"Legg til DNS-poster selv\"-knappen.",
      "breadcrumbs": {
        "step1": "Trinn 1: Domene, CMS og språk",
        "step2": "Trinn 2: Språk-DNS",
        "step3": "Trinn {{step}}: Installasjonsinstruksjoner"
      }
    },
    "form": {
      "urls": {
        "dash": "Bindestrek -",
        "underscore": "Understrek _",
        "title": "Oversett URL-er",
        "description": "Ønsker du å oversette på alle sider",
        "char_description": "Tegn som skal brukes for å erstatte uautoriserte tegn i URL-er",
        "advertisement_title": "⚠ Du har satt mange språk.\n",
        "advertisement": "Vi anbefaler vanligvis å begynne å oversette nettsteder med få språk først. Da får du en idé om hvor mange ord nettstedet ditt har. Det er også bedre for SEO, ettersom Google-roboter vil indeksere sidene dine raskere hvis du har færre sider først. Etter en uke kan du legge til noen flere språk, og så videre."
      },
      "url": {
        "title": "Url",
        "description": "Skriv inn hoveddomenets URL som starter med http:// eller https://",
        "placeholder": "Domenets URL",
        "advertisement_http": {
          "title": "Du bruker ikke https-protokollen",
          "description": "Vennligst sjekk at domenet ditt faktisk ikke bruker https-protokollen, som i dag anbefales."
        },
        "advertisement_www": {
          "title": "Ditt underdomene er ikke www",
          "description": "De fleste ganger er standard underdomene www (som https://www.mittdomene.com). Dette er kanskje ikke tilfellet for deg, men dobbeltsjekk at domenet du ønsker å legge til er det riktige."
        },
        "invalid_url": {
          "line1": "Vi har ikke klart å finne domenet ditt. Vennligst sjekk at domenet ditt er offentlig tilgjengelig via Internett og at det ikke videresendes til et annet sted.",
          "line2": "Hvis du er sikker på at domenet ditt er tilgjengelig, kan du hoppe over domenebekreftelse og trykke på \"Neste steg\"-knappen igjen",
          "contact": "I alle fall kan du kontakte oss på",
          "force": "Hopp over domenebekreftelse"
        },
        "invalid_subdomain_url": "Denne nettadressen er ikke tillatt. Underdomener må være i formatet: https://www.domain.tld eller https://domain.tld uten underkatalog."
      },
      "account": {
        "title": "Konto",
        "description": "Velg en konto å tilordne dette domenet til",
        "placeholder": "Velg konto...",
        "feedback": "Du må velge en konto"
      },
      "platform": {
        "title": "Plattform",
        "description": "Vennligst velg din nettplattform etter CMS-navn.",
        "learn": "Lær hvordan du velger den",
        "placeholder": "Søk plattform etter CMS-navn...",
        "info": {
          "title": "⚠ Denne plattformen er nylig lagt til.\n",
          "desc": "Denne nettstedbyggerplattformen støttes av Linguise, selv om den ble lagt til nylig. Hvis du opplever problemer, vennligst kontakt oss på direkte support-e-post:"
        },
        "description_read_only": "Plattformen nettstedet ditt bruker",
        "feedback": "Du må velge en plattform"
      },
      "language": {
        "title": "Språk",
        "description": "Velg hovedspråket til nettstedet ditt",
        "placeholder": "Velg språk...",
        "feedback": "Du må velge et språk",
        "description_read_only": "Hovedspråket til nettstedet ditt"
      },
      "token": {
        "title": "API-nøkkel",
        "description": "Dette er API-nøkkelen som skal kopieres til nettstedet ditt",
        "copy": "Kopier til utklippstavlen",
        "reset": "Tilbakestill API-nøkkel",
        "reset_confirm": "Vennligst bekreft tilbakestilling av API-nøkkel"
      },
      "languages": {
        "title": "Oversettelsesspråk",
        "description": "Velg språkene du ønsker at nettstedet ditt skal kunne oversettes til",
        "placeholder": "Velg språk...",
        "feedback": "Du må velge et språk"
      },
      "defaultRules": {
        "title": "Standardregler",
        "description": "Vi har definert et sett med regler som må brukes for å forbedre oversettelsen og unngå uønsket innhold som skal oversettes, som WordPress-dashbordet.\nDu kan fjerne eller redigere disse reglene senere hvis du ønsker det."
      },
      "disallow_deletion": "Du kan ikke slette domene med aktivt abonnement",
      "delete_confirm": "Vennligst bekreft sletting av domene",
      "delete": "Slett domene",
      "dynamic": {
        "title": "Oversett dynamisk innhold",
        "description": "Dynamisk innhold generert av JavaScript og AJAX-forespørsler vil bli oversatt (dette alternativet vil øke oversettelsesbruken din)"
      },
      "partial_translations": {
        "title": "Tillat delvis oversettelse",
        "description": "Hvis kontoen din har nådd sin oversettelseskvote men siden fortsatt krever oversettelse, kan Linguise fortsette å vise siden med innholdet som allerede er oversatt.\nNoen deler av siden vil imidlertid forbli uoversatte til du oppgraderer kvoten din.\n\nSelv om en liten mengde uoversatt innhold vanligvis ikke skader SEO, kan for mye uoversatt innhold påvirke brukeropplevelsen negativt.\nFor å håndtere dette kan du sette en terskel for prosentandelen uoversatt innhold som tillates på en side. Hvis den uoversatte andelen overskrider denne terskelen, blir brukerne automatisk omdirigert til originalspråkversjonen av siden.",
        "never": "Aldri"
      },
      "translate_error_pages": {
        "title": "Oversett feilsider",
        "description": "Linguise kan oversette alle feilsider, men hvis feilsiden din inneholder dynamisk innhold, som IP-adresse eller forespørsel-ID, bør du unngå å oversette disse sidene.",
        "not_found_page": {
          "title": "Oversett 404-side"
        },
        "error_page": {
          "title": "Oversett andre feilsider"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Eksisterende domene funnet",
          "description": "Et eksisterende domene ble funnet for denne brukeren, ønsker du å bruke det?"
        }
      },
      "search_tl": {
        "title": "Søk i oversettelser",
        "description": "Aktiver søk i oversettelser for din nettplattform (Eksperimentelt, dette alternativet vil øke oversettelsesbruken din)"
      },
      "shopify_promo": {
        "info": "Gode ​​nyheter! Vi har nå en Shopify-app du kan installere fra Shopify App Store",
        "hyperlink": "Klikk her og utfør Linguise-installasjonen fra appen.",
        "next_btn": "Gå til Shopify-butikken for å installere appen",
        "info_legacy": "Gode ​​nyheter! Vi har nå en Shopify-app du kan installere fra Shopify App Store",
        "description_legacy": "Velg plattformen «Shopify» i stedet for «Shopify Legacy»"
      },
      "wix_promo": {
        "info": "Gode nyheter! Vi har nå en Wix-app du kan installere fra Wix App Market.",
        "hyperlink": "Klikk her og utfør Linguise-installasjonen fra appen.",
        "next_btn": "Gå til Wix App Market for å installere appen",
        "info_legacy": "Gode nyheter! Vi har nå en Wix-app du kan installere fra Wix App Market.",
        "description_legacy": "Velg plattformen «Wix» i stedet for «Wix Legacy»"
      },
      "ai_disallow_deletion": "Du kan ikke slette dette domenet mens en AI-kvote fortsatt er tilgjengelig.\n\nTa kontakt med supportteamet vårt hvis du ønsker å slette dette domenet på",
      "language_removal": {
        "card": {
          "title": "Slett oversettelser for fjernede språk",
          "description": "Disse språkene er fjernet fra nettstedet ditt, men de lagrede oversettelsene teller fortsatt med i kvoten din. Slett dem for å få ordene tilbake.",
          "button": "Slett oversettelser"
        },
        "hint": "Ordene som ble brukt, legges tilbake i kvoten din. Du kan gjøre dette én gang hver {{days}}. dag per nettsted.",
        "modal": {
          "title": "Slette oversettelser?",
          "intro": "Disse oversettelsene slettes permanent:",
          "warning": "Dette kan ikke angres. Ordene som ble brukt, legges tilbake i kvoten din. Det kan ta noen minutter.",
          "limit": "Du kan gjøre dette én gang hver {{days}}. dag per nettsted.",
          "confirm": "Slett oversettelser"
        },
        "scheduled": "Oversettelsene slettes, og kvoten din oppdateres snart.",
        "cooldown": "Oversettelsene for dette nettstedet ble nylig slettet. Du kan slette dem igjen {{date}}.",
        "latest_completed": {
          "title": "Siste fullførte sletting",
          "description": "Se språkene som ble slettet, og ordene som ble tilbakeført til kvoten din.",
          "languages": "Slettede språk",
          "words_returned": "Ord tilbakeført til kvoten din: {{words}}",
          "completed_at": "Fullført {{date}}"
        },
        "status": {
          "recent_title": "Nylig sletting av oversettelser",
          "recent_description": "Følg den siste slettingen og se når du kan starte en ny.",
          "progress_title": "Fremdrift for sletting",
          "loading": "Kontrollerer fremdriften for slettingen...",
          "unavailable": "Kunne ikke laste inn fremdriften. Oppdater siden og prøv på nytt.",
          "label": "Status",
          "pending": "I kø",
          "processing": "Pågår",
          "completed": "Fullført",
          "failed": "Mislyktes",
          "unknown": "Status ikke tilgjengelig",
          "percent": "{{percent}} % fullført",
          "current_stage": "Gjeldende trinn: {{stage}}",
          "processed": "{{processed}} oppføringer behandlet",
          "processed_total": "{{processed}} av {{total}} oppføringer behandlet",
          "requested_at": "Forespurt {{date}}",
          "started_at": "Startet {{date}}",
          "completed_at": "Fullført {{date}}",
          "cooldown_period": "Du kan gjøre dette én gang hver {{days}}. dag per nettsted.",
          "cooldown_blocked": "En ny sletting kan ikke startes ennå.",
          "stage": {
            "queued": "Venter på å starte",
            "processing": "Pågår",
            "refund_summary": "Beregner returnerte ord",
            "search_translations": "Sletter søkeoversettelser",
            "url_translations": "Sletter URL-oversettelser",
            "translations": "Sletter oversettelser",
            "completed": "Fullført",
            "failed": "Mislyktes",
            "unknown": "Pågår"
          }
        },
        "forbidden": "Du har ikke tillatelse til å slette oversettelser."
      }
    },
    "main": {
      "edit": "Rediger domene",
      "add": "Legg til domene",
      "wizard": "Velkommen! Veiviser for opprettelse av nytt domene",
      "common": "Domene"
    },
    "notice": {
      "broken_card": "Vi klarte ikke å fornye planen din for {{url}} med nåværende betalingsmetode, vennligst oppdater betalingskortet ditt",
      "quota_reached": "Din oversettelseskvote for {{url}} er nådd, vennligst oppgrader for å gjenoppta oversettelsen av nettstedet ditt",
      "ai_no_subscription": "AI-oversettelse for {{url}} krever et aktivt abonnement eller aktiv prøveperiode. Den vil stoppe uten et slikt, vennligst oppgrader for å fortsette",
      "important": "Viktig",
      "quota_reached_button": "Oppgrader planen din nå",
      "broken_card_button": "Oppdater betalingskortet ditt",
      "ai_no_subscription_button": "Oppgrader planen din nå",
      "quota_warning": "Oversettelseskvoten din for {{url}} har nådd {{throttling_used_percent}}%, dette vil bli nullstilt om {{ttl}}",
      "locked": "Domenet {{url}} er for øyeblikket låst for migrering, du har fortsatt tilgang til nettstedet ditt, men kan ikke redigere eller legge til nye oversettelser!"
    },
    "subdomains": {
      "config_ok": "Underdomener DNS er konfigurert riktig.",
      "config_invalid": "Underdomener DNS krever ekstra konfigurasjon for å fungere.",
      "config_check": "Underdomener DNS-konfigurasjon sjekkes, vennligst vent...",
      "entri_timeout": "Entri rapporterer at spredningsprosessen for underdomener DNS har tidsutløp. Du må prøve på nytt eller gjøre det manuelt.",
      "entri_process": "DNS er lagt til med Entri og det tar vanligvis 10–30 minutter å spre (aktivere alle språkunderdomener som es.domain.com). Hvis DNS-validering ikke er ferdig etter 24 timer, kan du kontakte support: support@linguise.com",
      "entri_ok": "DNS-spredning pågår! Venter på ferdigstillelse...",
      "infos": "Du må legge til disse DNS-oppføringene i DNS-domenepostene dine for å aktivere oversettelsen. Klikk på avmerkingsknappen når det er gjort. Det er mulig at DNS-postene kan ta litt tid å overføres, så du må kanskje komme tilbake etter noen minutter eller timer.",
      "check": "Sjekk DNS-konfigurasjonen"
    },
    "subscription": {
      "next_payment_amount": "Kommende kostnader",
      "next_payment_date": "Neste betalingsdato",
      "invoice": {
        "header": "Fakturahistorikk",
        "date": "Dato",
        "amount_due": "Beløp",
        "status": "Status",
        "actions": "Handlinger",
        "description": "Når transaksjoner er tilgjengelige, kan du se dem her.",
        "status_text": {
          "draft": "Kladd",
          "failed": "Mislyktes",
          "open": "Venter",
          "paid": "Betalt",
          "retrying": "Forsøker på nytt",
          "uncollectible": "Ikke inndrivbar",
          "void": "Ugyldig"
        },
        "view": "Vis",
        "empty": "Ingen nylige fakturaer funnet for dette abonnementet",
        "retry_payment": "Prøv igjen"
      },
      "next_cancellation": "Oppsigelsesdato",
      "cancel": "Avslutt abonnement",
      "change_plan": "Endre plan",
      "change": "Endre",
      "suspend": "Sett betaling på pause",
      "resume": "Gjenoppta abonnement",
      "back": "Tilbake",
      "save": "Lagre",
      "confirm_resume": "Er du sikker på at du vil gjenoppta dette abonnementet?",
      "confirm_cancel": "Er du sikker på at du vil avslutte dette abonnementet?",
      "confirm_header": "Er du sikker?",
      "missing_status": "Dette abonnementet mangler",
      "not_found": "Ingen abonnement funnet for dette domenet",
      "confirm_manual_retry": "Er du sikker på at du vil prøve denne betalingen på nytt?",
      "no_payment_method": "Ukjent",
      "remove_billing": "Fjern",
      "shopify_maneged": "Dette abonnementet administreres av Shopify. Vennligst administrer det i Shopify-admin.",
      "unknown_plan": "Ukjent plan"
    }
  },
  "domain_listing": {
    "add": "Legg til nettsted",
    "select": "Velg et domene"
  },
  "editable": {
    "number": "nummer {{id}}"
  },
  "footer": {
    "about": "Om",
    "support": "Support"
  },
  "frontendEditor": {
    "main": "Sanntidsredigering",
    "description": "Live Editor hjelper deg med å redigere oversettelser direkte på nettstedet ditt.",
    "button": "Åpne Live Editor",
    "language_selection": "Velg oversettelsesspråk",
    "video_label": "Lær hvordan du bruker live-editoren"
  },
  "general": {
    "403": {
      "tab_title": "Oops - 403-feil",
      "title": "Tilgang nektet",
      "message": "Det ser ut som du ikke har tilgang til den forespurte siden.",
      "home": "Tilbake til startsiden"
    },
    "404": {
      "tab_title": "Oops - 404-feil",
      "title": "Siden ble ikke funnet",
      "message": "Det ser ut som du har tatt en feil sving. Ikke bekymre deg ... det skjer for de beste av oss. Her er et tips som kan hjelpe deg tilbake på sporet.",
      "home": "Tilbake til startsiden"
    },
    "500": {
      "tab_title": "500-feil",
      "title": "Intern serverfeil",
      "message": "Hva med å oppdatere siden? eller du kan kontakte oss",
      "home": "Tilbake til startsiden"
    },
    "fields": {
      "alert": "Noen felt er ugyldige, vennligst rett de ugyldige feltene.",
      "invalid": "Dette feltet er ugyldig",
      "phone_re": "Telefonnummeret er ugyldig",
      "phone_invalid": "Telefonnummeret er ugyldig",
      "email": "E-postfeltet er ugyldig"
    },
    "table": {
      "no_data": "Det er ingen data her ennå..."
    },
    "saving": "Lagrer ...",
    "save": "Lagre",
    "save_and_quit": "Lagre og avslutt",
    "invite": "Inviter",
    "cancel": "Avbryt",
    "yes": "Ja",
    "no": "Nei",
    "nextStep": "Neste steg",
    "loading": "Vennligst vent mens applikasjonen laster",
    "goback": "Gå tilbake",
    "manage": "Administrer",
    "delete": "Slett",
    "deleting": "Sletter ...",
    "confirm": "Bekreft",
    "unknown": "Ukjent",
    "hide": "Gjemme",
    "show": "Vise",
    "on": "På",
    "off": "Av",
    "default": "Standard"
  },
  "home": {
    "header": "Hjem",
    "manage": "Administrer abonnement",
    "canceled": "Planlagt for kansellering",
    "activate_now": "Aktiver nå",
    "activate_plan_now": "Abonner nå",
    "upgrade_plan_now": "Oppgrader plan nå",
    "trial_message_part_1": "Du er for øyeblikket på prøveplanen, ",
    "trial_message_part_2": "du kan aktivere et medlemskap når som helst.",
    "add": "Legg til domene",
    "table": {
      "title": "Domener",
      "description": "Liste over dine domener, klikk på domenet for å administrere oversettelser"
    },
    "domains": {
      "empty": "Du har ingen domener på denne kontoen"
    },
    "accountsList": {
      "title": "Kontoer",
      "add": "Legg til ny konto",
      "name": "Kontonavn"
    },
    "update_credit_card": "Oppdater kredittkortdetaljer",
    "cancelling_subs": "Kansellerer {{0}}",
    "resume_subscription": "Gjenoppta abonnement",
    "shopify_managed": "Administrert av Shopify",
    "trial_ends_at": "Slutter kl. {{0}}",
    "free_trial": "Gratis prøveversjon",
    "no_subs": "Ingen aktiv abonnement"
  },
  "invoices": {
    "title": "Fakturaer",
    "list": {
      "title": "Fakturaliste"
    },
    "table": {
      "customer": "Kunde",
      "domain": "Domene",
      "amountPaid": "Beløp betalt",
      "status": "Status",
      "date": "Dato",
      "invoice": "Faktura",
      "pay": "Betal faktura",
      "actions": "Handlinger",
      "deleted_domain": "Domene slettet",
      "plan_name": "Abonnement",
      "action": "Handling"
    },
    "listPending": {
      "title": "Ventende fakturaer"
    }
  },
  "language_settings": {
    "display": "Visning av språkliste",
    "position": "Posisjon",
    "display_help_text": "Vis flagg og/eller språknavn. Språkbytterens standardposisjon kan være hvor som helst i innholdet eller i en fast posisjon som forblir fast eller beveger seg ved scrolling",
    "side_by_side": "Side om side",
    "dropdown": "Nedtrekksmeny",
    "popup": "Popup",
    "flag": "Flagg",
    "lang_name": "Språknavn",
    "lang_short_name": "Korte navn",
    "positions": {
      "in_place": "På stedet",
      "top_left": "Øverst til venstre",
      "top_left_no_scroll": "Øverst til venstre (uten scrolling)",
      "top_right": "Øverst til høyre",
      "top_right_no_scroll": "Øverst til høyre (uten scrolling)",
      "bottom_left": "Nederst til venstre",
      "bottom_left_no_scroll": "Nederst til venstre (uten scrolling)",
      "bottom_right": "Nederst til høyre",
      "bottom_right_no_scroll": "Nederst til høyre (uten scrolling)"
    },
    "lang_names_display": {
      "title": "Visning av språknavn",
      "help_text": "I språkbytteren kan du vise språknavnene på engelsk eller på originalspråket, f.eks. French eller Français",
      "english": "Engelsk",
      "native_languages": "Opprinnelige språk"
    },
    "flag_shape": {
      "title": "Flaggform",
      "help_text": "Bruk runde eller rektangulære SVG-flaggikoner",
      "round": "Rund",
      "rectangular": "Rektangulær"
    },
    "english_flag_type": {
      "title": "Engelsk flaggtype",
      "help_text": "Bruk Storbritannias eller USAs flagg for engelsk",
      "usa": "USA-flagg",
      "great_britain": "Storbritannias flagg"
    },
    "german_flag_type": {
      "title": "Tysk flaggtype",
      "help_text": "Bruk Østerrikes eller Tysklands flagg for tysk",
      "german": "Tysk flagg",
      "austria": "Østerriksk flagg"
    },
    "spain_flag_type": {
      "title": "Spansk flaggtype",
      "help_text": "Bruk Mexicos eller Spanias flagg for spansk",
      "spanish": "Spansk flagg",
      "mexico": "Meksikansk flagg",
      "peruvian": "Peruansk flagg"
    },
    "portugal_flag_type": {
      "title": "Portugisisk flaggtype",
      "help_text": "Bruk Portugals eller Brasils flagg for portugisisk",
      "portugal": "Portugisisk flagg",
      "brazil": "Brasiliansk flagg"
    },
    "taiwanese_flag_type": {
      "title": "Taiwansk flaggtype",
      "help_text": "Bruk Taiwans eller Kinas flagg for taiwansk",
      "taiwanese": "Taiwansk flagg",
      "chinese": "Kinesisk flagg"
    },
    "flag_border_radius": {
      "title": "Flagg hjørneradius (px)",
      "help_text": "Hvis du bruker rektangulær flaggform kan du angi egendefinert hjørneradius i piksler"
    },
    "flag_width": {
      "title": "Flaggstørrelse (px)",
      "help_text": "Velg flagg-størrelse i piksler. Dette påvirker ikke bildevekt siden det er SVG-format"
    },
    "lang_color": {
      "color_title": "Farge på språknavn",
      "color_help_text": "Velg en standard tekstfarge for språknavn",
      "hover_color_title": "Farge på språknavn ved hover",
      "hover_color_help_text": "Velg tekstfarge for språknavn når musen holdes over",
      "color_popup_title": "Farge på språk i popup",
      "color_popup_help_text": "Farge på språktittel i popup eller nedtrekksområder",
      "hover_color_popup_title": "Farge på språk ved hover i popup",
      "hover_color_popup_help_text": "Velg tekstfarge for språktittel ved mus-over i popup eller nedtrekksområder"
    },
    "flag_box_shadow": {
      "shadow_title": "Skygge på flagg",
      "shadow_help_text": "Farge og størrelse på skygge rundt språkflagg",
      "hover_shadow_title": "Skygge på flagg ved hover",
      "hover_shadow_help_text": "Farge og størrelse på skygge rundt språkflagg når musen holdes over",
      "shadow_h_offset": "Horisontal skyggeforskyving (px)",
      "shadow_v_offset": "Vertikal skyggeforskyving (px)",
      "shadow_blur": "Skyggeutvisking (px)",
      "shadow_spread": "Skyggeutbredelse (px)",
      "shadow_color": "Skyggefarge"
    },
    "order": "Rekkefølge på språk",
    "language_order_help": "Rekkefølgen språk vises i språkbytteren. Du kan dra og slippe for å endre rekkefølge.",
    "order_reset": "Tilbakestill rekkefølge",
    "language_order_dragdrop": "Du kan dra og slippe språk for å endre rekkefølge.",
    "popup_lang_name": "Popup-språknavn",
    "preview": "Forhåndsvisning av språk"
  },
  "link": {
    "form": {
      "original": {
        "title": "Opprinnelig kilde",
        "description": "Legg til din opprinnelige lenke-URL og erstatt den nedenfor per språk for oversetting",
        "srcset_description": "Du redigerer en bilde-URL. Les dokumentasjonen, spesielt hvis du bruker srcset eller ikke vet hva det er",
        "link": "Lenke",
        "match_link": "Treffmodus",
        "match_exact": "Eksakt",
        "match_wildcard": "Jokertegn",
        "match_regex": "Regulært uttrykk"
      },
      "alternative_languages": {
        "title": "Lenker som skal erstattes",
        "description": "Erstatt medialenker og eksterne lenker på tvers av sidene dine, etter språk…",
        "link": "Lenke som skal erstattes"
      },
      "error": {
        "atLeastOne": "Legg til minst én oversettelse.",
        "url": "URL-en er ugyldig",
        "extension": "Lenken må ha en filtype, men kan ikke være .html eller .php. Lenken må heller ikke inneholde språksti, f.eks. «/fr»",
        "regex": "Det regulære uttrykket er ugyldig",
        "wildcard": "Jokerlenken har et ugyldig protokoll"
      }
    },
    "main": {
      "parent": "Lenker",
      "edit": "Rediger lenke"
    }
  },
  "links": {
    "title": "Administrasjon av medialenker og eksterne lenker",
    "description": "Vis og rediger nettstedets medialenker eller eksterne lenker.",
    "add": "Legg til lenke",
    "delete": "Slett lenke",
    "table": {
      "original": "Original",
      "language": "Språk",
      "translation": "Oversettelse",
      "action": "Handling",
      "delete_confirm": "Bekreft sletting av lenke"
    }
  },
  "members": {
    "header": "Medlemmer",
    "invite": "Inviter nytt medlem",
    "modal": {
      "inviteHeader": "Inviter nytt medlem",
      "editHeader": "Rediger medlem",
      "detachHeader": "Koble fra medlem",
      "detachBody": "Er du sikker på at du vil koble medlemmet fra denne kontoen?",
      "selfDetachBody": "Er du sikker på at du vil koble deg selv fra denne kontoens administrasjon? Etterpå vil du ikke lenger ha tilgang til data knyttet til kontoen."
    },
    "table": {
      "title": "Medlemsliste",
      "description": "Medlemsroller og tilgang til domener",
      "name": "Navn",
      "email": "E-post",
      "websites": "Nettsteder",
      "languages": "Språk",
      "role": "Rolle",
      "status": "Status",
      "resendInvite": "send på ny",
      "inviteSent": "invitasjon sendt",
      "actions": "Handlinger",
      "edit": "Rediger",
      "detach": "Koble fra",
      "empty": "Du har ingen medlemmer ennå",
      "all_website": "Alle nettsteder og språk",
      "roles": {
        "admin": "Administrator",
        "manager": "Leder",
        "translator": "Oversetter"
      },
      "statuses": {
        "pending": "Venter",
        "accepted": "Akseptert",
        "declined": "Avslått"
      }
    },
    "errors": {
      "role": "Du må velge en rolle",
      "domains": "Du må velge minst ett nettsted for valgt rolle",
      "languages": "Du må velge minst ett språk for valgte nettsteder"
    },
    "inviteSent": "Invitasjonen er sendt"
  },
  "pagination": {
    "showing": "Viser {{limit}} av {{total}} resultater",
    "showing_only_count": "Viser {{limit}} resultater"
  },
  "payments_method": {
    "header": "Betalingsmetoder",
    "table": {
      "title": "Oversikt over betalingsmetoder",
      "description": "Tilknyttede betalingsmetoder på kontoen din",
      "default": "Standard",
      "action_edit_remove": "Rediger eller fjern",
      "action_remove": "Fjern",
      "action_default": "Bruk som standard",
      "action_fallback": "Bruk som reserve",
      "expires": "Utløper",
      "add_new_card": "Legg til betalingsmetode",
      "action_fallback_remove": "Fjern fra reserve",
      "fallback": "Reserve",
      "action_edit": "Rediger",
      "action_delete": "Slett",
      "action_default_remove": "Fjern som standard",
      "domain_count@@one": "Brukes av {{count}} domener",
      "domain_count@@other": "Brukt av {{count}} domener"
    },
    "paypal_bind": {
      "button": "Koble PayPal-konto",
      "button_load": "Kobler…",
      "disconnected": "Ikke tilkoblet",
      "success": "PayPal-kontoen din er nå koblet til, 5 USD trekkes fra neste faktura!",
      "success_no_promo": "PayPal-kontoen din er nå koblet til",
      "error": "Det oppsto en feil",
      "success_header": "Vellykket"
    },
    "card_add": {
      "header": "Legg til nytt kort",
      "success": "Nytt kort koblet til Linguise!",
      "terms": "Ved å oppgi kortinformasjonen godtar du at Linguise belaster kortet ditt for fremtidige betalinger i henhold til våre tjenestevilkår."
    },
    "card_detail": {
      "header": "Kortinformasjon",
      "delete": {
        "error": "Du kan ikke slette denne betalingsmetoden fordi den har aktive abonnementer!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Abonnementer på denne betalingsmetoden",
        "header_domain": "Domene",
        "header_plan": "Abonnement",
        "header_status": "Status",
        "header_actions": "Handlinger",
        "cancelling": "Kanselleres: {{0}}",
        "next_payment": "Neste betaling: {{0}}",
        "action_renew": "Forny",
        "no_subs_header": "Ingen abonnementer å vise",
        "no_subs_desc": "Når et abonnement opprettes med dette kortet, vises all informasjon her",
        "action_manage": "Administrer"
      },
      "status": {
        "active": "Aktiv",
        "canceled": "Kansellert",
        "incomplete": "Ubetalt",
        "incomplete_expired": "Ubetalt (utløpt)",
        "missing": "Feil",
        "past_due": "Forfalt",
        "trialing": "Prøve",
        "unpaid": "Ubetalt"
      }
    },
    "delete_confirm_body": "Er du sikker på at du vil slette denne betalingsmetoden? Denne handlingen kan ikke angres!",
    "delete_confirm_header": "Slette betalingsmetode?",
    "card_edit": {
      "header": "Rediger kort",
      "billing_header": "Faktureringsinformasjon",
      "address_error": "Adresse er påkrevd!",
      "card_number": "Kortnummer",
      "card_expiry": "Utløpsdato",
      "expiry_error_month": "Ugyldig måned oppgitt",
      "expiry_error_year": "Ugyldig år oppgitt",
      "expiry_error_expired": "Ditt korts utløpsår ligger i fortiden.",
      "card_header": "Kortinformasjon",
      "expiry_error_empty": "Dette feltet er påkrevd!"
    }
  },
  "plans": {
    "per": "per",
    "wordsTranslated": "ord oversatt",
    "current": "Gjeldende",
    "archived": "Arkivert",
    "day": "dag",
    "week": "uke",
    "month": "måned",
    "year": "år",
    "activate": "Aktiver",
    "cancel": "Avbryt",
    "change": "Endre",
    "upgrade": "Oppgrader",
    "downgrade": "Nedgrader",
    "resume": "Gjenoppta",
    "notEnoughWords": "Ikke nok ord",
    "yearIntervalOnly": "Kan ikke bytte fra årlig plan",
    "subsCanceled": "Det pågår allerede en annen kansellering av abonnement",
    "wordsUnlimited": "Ubegrenset antall ord",
    "tabs": {
      "day": "Daglige priser",
      "week": "Ukespriser",
      "month": "Månedlige priser",
      "year": "Årlige priser",
      "sub_texts": {
        "day": "Én fast pris hver dag",
        "week": "Én fast pris hver uke",
        "month": "Én fast pris hver måned",
        "year": "Én måned gratis, én faktura per år"
      }
    },
    "details": {
      "new_languages": "Legg til nye språk når som helst",
      "one_month_trial": "Én måneds gratisforsøk for hvert nytt nettsted",
      "multi_content_indexed": "100 % av flerspråklig innhold indeksert",
      "translate_new_content": "Oversett nytt innhold umiddelbart",
      "free_installation": "Gratis installasjon og oppsett",
      "compared_monthly_plan": "Én måned gratis sammenlignet med månedlige planer",
      "risk_free_recurring": "Risikofritt ved gjentatte betalingsfeil",
      "unlimited_languages": "Ubegrensede språk og sidevisninger",
      "high_server_resources": "Høye serverressurser",
      "billed": {
        "day": "Faktureres daglig",
        "week": "Faktureres ukentlig",
        "month": "Faktureres månedlig",
        "year": "Faktureres årlig"
      },
      "request_max_size": "{{0}} maks forespørrelsesstørrelse"
    },
    "frequent_question": {
      "title": "Ofte stilte spørsmål",
      "questions": {
        "trial": {
          "question": "Kan jeg bruke prøveperioden på et nytt nettstedsdomene?",
          "answer": "Ja, vi tilbyr en 30 dagers gratisforsøk for hvert nye nettstedsdomene du legger til kontoen din. Slik kan du teste oversettelses­tjenesten fullt ut på ditt nye nettsted."
        },
        "seo": {
          "question": "Hvor lang tid tar det før SEO-en min forbedrer seg?",
          "answer": "Innhold – og flerspråklig innhold – bruker tid på å bli fullstendig indeksert og høyt rangert. Avhengig av nettstedets trafikk og størrelse tar det mellom 3 og 6 uker."
        },
        "quota": {
          "question": "Er menneskelige oversettelser inkludert i kvoten?",
          "answer": "Nei, ordgrensen gjelder kun automatiske maskinoversettelser. En oversetter kan redigere automatiske oversettelser manuelt uten begrensning."
        }
      }
    },
    "best_offer": "Beste tilbud",
    "period": {
      "days@@one": "dag",
      "days@@other": "{{count}} dager",
      "hours@@one": "time",
      "hours@@other": "{{count}} timer",
      "minutes@@one": "minutt",
      "minutes@@other": "{{count}} minutter",
      "seconds@@one": "sekund",
      "seconds@@other": "{{count}} sekunder"
    },
    "words": {
      "billion": "{{value}} mrd",
      "million": "{{value}} mill",
      "thousand": "{{value}} k"
    },
    "throttling_info": "{{words}} ord per {{period}}"
  },
  "profile": {
    "welcome": "Velkommen!",
    "account": "Min konto",
    "subscriptions": "Abonnement",
    "logout": "Logg ut"
  },
  "register": {
    "errors": {
      "password": "Minimum 8 tegn, enhver type tegn"
    }
  },
  "route": {
    "dashboard": "Dashbord",
    "rules": "Regler",
    "translations": "Oversettelser",
    "search_translations": "Søke­spørringer",
    "urls_translations": "URL-oversettelser",
    "links": "Medier ogEksterne lenker",
    "online_editor": "Direkte redigerer",
    "settings": "Innstillinger",
    "domain": {
      "finish": "Innstillinger",
      "preconfig": "Innstillinger"
    },
    "home": "Hjem",
    "domain_list": "Domene­liste",
    "members": "Medlemmer",
    "invoices": "Fakturaer",
    "billing": "Fakturerings­detaljer",
    "language_display": "Språkflagg-visning",
    "payment_methods": "Betalings­metoder",
    "ai_translation": "AI-oversettelse",
    "ai_translation_settings": "Innstillinger",
    "ai_translation_pricing": "Priser"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Tekst som skal ignoreres",
        "add": "Legg til ny",
        "title": "Tekst som skal ignoreres",
        "description": "Legg til én eller flere tekster som skal ignoreres",
        "ignore_case": "Ignorer store/små bokstaver"
      },
      "html_content": {
        "title": "Bruk på HTML-innhold",
        "description": "Bruk regelen på hele innholdet eller ved å velge en bestemt CSS-selektor",
        "all_page": "Hele siden",
        "css_selector": "CSS-selektor",
        "label": "CSS-selektor",
        "placeholder": "Selektor å bruke på",
        "add": "Legg til ny"
      },
      "apply_to_urls": {
        "title": "Bruk på URL-er",
        "description": "Velg spesifikke URL-er der du vil at regelen skal gjelde",
        "all_urls": "Alle URL-er",
        "selected_urls": "Valgte URL-er",
        "label": "URL å bruke på",
        "placeholder": "URL å bruke på",
        "original_url": "Opprinnelige URL-er",
        "translated_url": "Oversatt URL",
        "wildcard": "Jokertegn",
        "regex": "Regulært uttrykk",
        "add": "Legg til ny",
        "expression": "Uttrykkstype"
      },
      "apply_urls": {
        "title_exclude": "Ekskluder i URL-er",
        "title_replace": "Erstatt i URL-er",
        "title_description": "Bruk også denne regelen på oversettelse av URL-er"
      },
      "apply_languages": {
        "title": "Bruk på språk",
        "description": "Velg spesifikke språk der du vil at regelen skal gjelde",
        "all_languages": "Alle språk",
        "selected_languages": "Valgte språk",
        "placeholder": "Velg språk …",
        "feedback": "Du må velge et språk"
      },
      "name": {
        "title": "Tittel",
        "description": "Gi regelen din en tittel for enkelhetens skyld",
        "placeholder": "Regelnavn"
      },
      "type": {
        "title": "Type",
        "description": "Velg hvilken type regel du vil legge til",
        "text_ignore": "Tekstignorering",
        "text_replace": "Teksterstatning",
        "content_exclusion": "Innholdsekskludering",
        "url_exclusion": "Ekskludering etter URL",
        "ignore_inline": "Ignorer inlinje",
        "full_description": {
          "text_ignore": "Legg til regler for å unngå at visse tekster oversettes. Det kan være produktnavnet, merkenavnet eller andre tekniske elementer du ikke vil ha oversatt.",
          "text_replace": "Teksterstatning lar deg erstatte noe tekst med den oversettelsen du ønsker; det kan være nødvendig når oversettelsen ignorerer konteksten.",
          "content_exclusion": "Innholdsekskludering hjelper deg med å unngå oversettelse av visst innhold på siden.\nHvis du vil ekskludere en hel side fra oversettelse (ingen flerspråklig URL i det hele tatt for denne siden og intet oversatt innhold), bruk typen \"Ekskludering etter URL\".",
          "url_exclusion": "Ekskludering av sideoversettelse hjelper deg med å angi hvilke sider du ikke vil oversette.",
          "ignore_inline": "Unngå å oversette visst innhold som inlinjeinnhold; i stedet oversettes hver tagg separat."
        }
      },
      "text_replace": {
        "title": "Tekst som skal erstattes",
        "description": "Erstatt visst tekst med din egen oversettelse. Erstatt hvilken som helst tekst over hele sidene, etter språk …",
        "text_to_replace": "Tekst som skal erstattes",
        "ignore_case": "Ignorer store/små bokstaver",
        "text_type": "Erstatning i oversettelse",
        "text_type_original": "Original",
        "text_type_translation": "Oversettelse",
        "keep_case": "Prøv å beholde store/små bokstaver",
        "add": "Legg til ny"
      },
      "content_exclusion": {
        "title": "Innholdsekskludering",
        "description": "Velg én eller flere CSS-selektorer som ikke skal oversettes",
        "label": "CSS-selektor",
        "placeholder": "Selektor å bruke på",
        "add": "Legg til ny"
      },
      "multilingual_url": {
        "title": "Bruk flerspråklig URL",
        "description": "Hvis satt til Ja, blir URL-en IKKE oversatt, men siden forblir flerspråklig med oversatt innhold",
        "live_example_title": "Sanntidseksempel",
        "live_example_description": "Kilde-URL: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "Generert URL: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "Generert URL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Bruk regelen på statisk innhold, dynamisk innhold eller begge deler",
        "title": "Bruk på innhold",
        "all": "Alt innhold",
        "static": "Statisk innhold",
        "dynamic": "Dynamisk innhold"
      },
      "force_apply_urls": {
        "title_description": "Tving frem denne regelen på all oversettelse av URL-er, inkludert eksisterende oversettelser!",
        "title_replace": "Tvingerstatning i URL-er",
        "title_exclude": "Tvingekskludering i URL-er",
        "warning": "Advarsel",
        "warning_part1": "Å sette dette til \"Ja\" kan ødelegge URL-oversettelsene på nettstedet ditt.",
        "warning_part2": "Dette kan midlertidig eller permanent generere 404-side; fortsett bare hvis du forstår konsekvensene.",
        "warning_replacement_original": "Ekstra advarsel: Du prøver å erstatte originalt innhold som kan påvirke URL; oversettelsen kan mislykkes ettersom Linguise ikke klarer å finne de opprinnelige URL-ene på riktig måte"
      }
    },
    "main": {
      "parent": "Regler",
      "edit": "Rediger regel",
      "add": "Ny regel"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" blir ignorert i innholdet og i URL-en",
      "preview_single": "\"{{text_ignore}}\" blir ignorert i innholdet",
      "preview_more_with_url": "\"{{text_ignore}}\" og {{count}} flere blir ignorert i innholdet",
      "preview_more": "\"{{text_ignore}}\" og {{count}} flere blir ignorert i innholdet",
      "other_parameters": "Andre parametere er satt for denne regelen; klikk redigeringsknappen for mer informasjon"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" erstattes av \"{{replacement}}\" i innholdet og i URL-ene",
      "preview_single": "\"{{original}}\" erstattes av \"{{replacement}}\" i innholdet",
      "preview_more_with_url": "\"{{original}}\" erstattes av \"{{replacement}}\" i innholdet og i URL-ene, og {{nb}} flere",
      "preview_more": "\"{{original}}\" erstattes av \"{{replacement}}\" i innholdet, og {{nb}} flere",
      "other_parameters": "Andre parametere er satt for denne regelen; klikk redigeringsknappen for mer informasjon"
    },
    "content_exclusion": {
      "selectors": "{{nb}} CSS-selektor(er) ekskludert fra oversettelse",
      "other_parameters": "Andre parametere er satt for denne regelen; klikk redigeringsknappen for mer informasjon"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URL-er er ekskludert fra oversettelse, men beholder fremdeles det flerspråklige prefikset",
      "some": "{{nb}} URL-er er fullstendig ekskludert fra oversettelse",
      "all_multilingual": "alle URL-er er ekskludert fra oversettelse, men beholder fremdeles det flerspråklige prefikset",
      "all": "alle URL-er er fullstendig ekskludert fra oversettelse",
      "other_parameters": "Andre parametere er satt for denne regelen; klikk redigeringsknappen for mer informasjon"
    },
    "ignore_inline": {
      "elements": "All inlinje-innhold blir oversatt som blokkinnhold på siden",
      "all_elements": "Noe inlinje-innhold blir oversatt som blokkinnhold på siden",
      "other_parameters": "Andre parametere er angitt for denne regelen. Klikk på redigeringsknappen for å få mer informasjon."
    },
    "title": "Regeladministrasjon",
    "description": "Administrer utelatelser og erstatninger i oversettelsesinnholdet over hele nettstedet",
    "add": "Legg til ny regel",
    "table": {
      "title": "Tittel",
      "no_data": "Ingen regler her ennå",
      "type": "Type",
      "preview": "Forhåndsvisning av regel",
      "action": "Handling",
      "delete_confirm": "Bekreft sletting av regel",
      "types": {
        "text_ignore": "Tekst ignorer",
        "text_replace": "Erstatt tekst",
        "content_exclusion": "Ekskluder innhold",
        "url_exclusion": "Ekskluder URL",
        "ignore_inline": "Ignorer inlinje",
        "unknown": "Ukjent regel"
      }
    },
    "apply_on_content": {
      "static": "Denne regelen vil kun gjelde for statisk innhold",
      "dynamic": "Denne regelen vil bare gjelde for dynamisk innhold"
    }
  },
  "search_translations": {
    "title": "Administrasjon av søkespørringer",
    "description": "List alle nettstedets oversettelser brukt i søkeskjemaer (fra oversatt språk til domenets grunnspråk)",
    "filter_languages": "Filtrer etter språk...",
    "filter_original": "Filtrer tekst på opprinnelig språk",
    "filter_translation": "Filtrer etter oversatt tekst",
    "table": {
      "original": "Original",
      "language": "Språk",
      "translation": "Oversettelse"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Kunne ikke abonnere!",
      "title": "Kunne ikke abonnere!",
      "subtitle": "Det oppsto en feil under behandling av abonnementet ditt.",
      "home": "Gå tilbake til startsiden",
      "generic": "En ukjent feil har oppstått på Linguise-siden, vennligst kontakt administrator!"
    },
    "success": {
      "home": "Administrer domenets oversettelser",
      "message": "Vi er forpliktet til å gi deg den beste oversettelsesopplevelsen. Vårt ekspertteam er tilgjengelig for å hjelpe deg med eventuelle spørsmål eller støtte du måtte trenge. For å komme i gang, klikk på knappen nedenfor.",
      "subtitle": "Takk for at du valgte Linguise oversettelsestjeneste",
      "title": "Abonnement aktivert!",
      "tab_title": "Takk for abonnementet!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "Abonnement aktivert!",
      "title": "Abonnement aktivert!",
      "subtitle": "Takk for at du valgte Linguise oversettelsestjeneste",
      "message": "Vi er forpliktet til å gi deg den beste oversettelsesopplevelsen. Vårt ekspertteam er tilgjengelig for å hjelpe deg med eventuelle spørsmål eller støtte du måtte trenge. For å komme i gang, klikk på knappen nedenfor.",
      "home": "Administrer domenets oversettelser"
    },
    "edit": {
      "title": "Administrer abonnement"
    },
    "list": {
      "title": "Abonnementsliste",
      "description": "Oversikt over domenets abonnementer"
    },
    "table": {
      "domain": "Domene",
      "plan": "Plan",
      "status": "Status",
      "card": "Kort",
      "usage": "Bruk",
      "actions": "Handlinger",
      "payment_method": "Betalingsmåte"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} ord",
      "paidOffered": "{{words_used}} / {{words_allowed}} ord\n(Inkludert {{free_words}} gratis ord)"
    },
    "popup": {
      "dueToday": "Totalt forfall i dag",
      "nextPeriod": "Fra og med {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Velg en konto"
    }
  },
  "translation": {
    "main": {
      "parent": "Oversettelser",
      "edit": "Rediger oversettelse"
    },
    "form": {
      "original": {
        "title": "Original på {{language}}"
      },
      "is_inline": "Denne oversettelsen er laget fra inlinjeinnhold.",
      "inline_editor": {
        "count_warning": "Antallet innebygde områder samsvarer ikke med originalen ({{current}} av {{expected}}).",
        "restore_original": "Gjenopprett original tekst",
        "insert_placeholder": "Sett inn plassholder",
        "drag": "Dra for å endre rekkefølgen på området",
        "area": "Innebygd område {{index}}",
        "restore": "Gjenopprett manglende innebygde områder"
      },
      "translation": {
        "title": "Oversettelse på {{language}}",
        "description": "Oversettelsen du ønsker å overstyre"
      }
    },
    "copy": {
      "title": "Kopier til den manuelle oversettelsen",
      "label": "Kopier til manuell"
    },
    "level": {
      "base": {
        "title": "Grunnoversettelse",
        "subtitle": "Automatisk · Linguise Cloud-oversettelse",
        "empty": "Ingen grunnoversettelse for denne teksten.",
        "overridden": "Valget ditt er lagret, men den nyeste AI-forbedrede oversettelsen vises i stedet fordi “Overstyr manuelle og valgte oversettelser” er satt til Ja i innstillingene for AI-oversettelse. Slå av innstillingen for å bruke valget ditt."
      },
      "not_generated": "Ikke generert",
      "none": "Ingenting ennå",
      "ai": {
        "title": "AI-forbedret oversettelse",
        "subtitle": "Automatisk · Linguise AI",
        "empty_title": "Ikke generert for denne teksten ennå",
        "empty_description": "Linguise AI gir mer naturlige oversettelser ved å bruke konteksten til siden og nettstedet ditt. Slik får du en her:",
        "empty_step_1": "Gå til AI-oversettelse › Innstillinger og sett Aktiver AI-oversettelse til “Bare regler”, “Bare live-editor” eller “Regler og live-editor”.",
        "empty_step_2": "Bruk den med en regel som passer til denne siden, eller aktiver den side for side fra live-editoren.",
        "empty_step_3": "Den AI-forbedrede oversettelsen vises her når den er generert. Den bruker AI-kredittene dine.",
        "open_settings": "Åpne innstillinger for AI-oversettelse",
        "open_editor": "Åpne live-editoren",
        "overrides_selection": "Valget ditt er lagret, men denne AI-forbedrede oversettelsen vises i stedet fordi “Overstyr manuelle og valgte oversettelser” er satt til Ja i innstillingene for AI-oversettelse. Slå av innstillingen for å bruke valget ditt.",
        "overrides_version": "Versjonen du valgte er lagret, men den nyeste AI-forbedrede versjonen vises i stedet fordi “Overstyr manuelle og valgte oversettelser” er satt til Ja i innstillingene for AI-oversettelse. Slå av innstillingen for å bruke den valgte versjonen."
      },
      "manual": {
        "title": "Manuell oversettelse",
        "subtitle": "Skrevet av deg · har prioritet over automatiske oversettelser",
        "empty": "Tom",
        "saved_but_overridden": "Lagret som ditt valg, men vises ikke automatisk fordi “Overstyr manuelle oversettelser” er satt til Ja i innstillingene for AI-oversettelse: den AI-forbedrede oversettelsen vinner til den innstillingen slås av.",
        "ignored": "Vises ikke automatisk fordi “Overstyr manuelle oversettelser” er satt til Ja i innstillingene for AI-oversettelse. Velg den for å bruke den for denne teksten.",
        "label": "Din oversettelse",
        "placeholder": "Skriv din egen oversettelse...",
        "last_updated": "Sist redigert {{date}}",
        "save_hint": "Når du lagrer en manuell oversettelse, blir den aktiv.",
        "delete": "Slett manuell oversettelse",
        "delete_confirm": "Bekreft sletting av den manuelle oversettelsen"
      }
    },
    "history": {
      "title": "AI-forbedrede versjoner",
      "subtitle": "Hver regenerering fra live-editoren beholdes",
      "unknown_model": "Ukjent modell",
      "current": "Gjeldende",
      "restore": "Gjenopprett denne versjonen",
      "restore_note": "Ved gjenoppretting blir den versjonen den gjeldende AI-forbedrede oversettelsen. Ingenting slettes.",
      "version_of": "Versjon {{current}} av {{total}}",
      "hide": "Skjul historikk ({{total}})",
      "show": "Vis historikk ({{total}})"
    },
    "choose": {
      "title": "Oversettelser på {{language}} · velg den besøkende ser",
      "current": "For øyeblikket på nettstedet ditt:",
      "priority": "Standardprioritet: Manuell › AI-forbedret › Grunn. Valget ditt lagres kun for denne oversettelsen.",
      "reset": "Tilbakestill til standardprioritet",
      "reset_title": "Glem valget ditt for denne teksten og bruk standardprioriteten igjen",
      "resetting": "Tilbakestiller ..."
    }
  },
  "translations": {
    "title": "Administrasjon av oversettelser",
    "description": "List og rediger alle nettstedets oversettelser; for visuell oversettelse bruk Live Editor",
    "filter_languages": "Filtrer etter språk...",
    "filter_original": "Filtrer tekst på opprinnelig språk",
    "filter_translation": "Filtrer etter oversatt tekst",
    "table": {
      "original": "Original",
      "language": "Språk",
      "action": "Handling",
      "base": "Grunn",
      "ai": "AI-forbedret",
      "manual": "Manuell"
    },
    "filter_exact": "Eksakt treff",
    "badge": {
      "active": "Aktiv",
      "overrides_manual": "Overstyrer manuell"
    },
    "cell": {
      "none": "ingen",
      "not_generated": "ikke generert",
      "ignored": "Ignorert – AI-regel vinner"
    },
    "tabs": {
      "all": "Alle",
      "manual": "Har manuell",
      "ai": "Har AI-forbedret",
      "base": "Kun grunn"
    },
    "levels_hint": "Hver tekst har opptil 3 nivåer — det som er merket Aktiv, er det besøkende ser."
  },
  "url": {
    "main": {
      "parent": "URL-er",
      "edit": "Rediger URL-oversettelse"
    },
    "form": {
      "original": {
        "title": "Original på {{language}}"
      },
      "translation": {
        "title": "URL-oversettelse på {{language}}",
        "description": "URL-en du ønsker å overstyre",
        "placeholder": "Overstyring av URL-oversettelse",
        "invalid_full": "Du prøver å endre med ugyldig format; du bør bare endre slugs/pathname i URL-oversettelsen",
        "invalid": "Ugyldig URL/sti oppgitt"
      }
    }
  },
  "urls": {
    "title": "Administrasjon av URL-er",
    "description": "List og rediger alle nettstedets oversatte URL-innhold (avansert, vær oppmerksom på 404-feil)",
    "filter_languages": "Filtrer etter språk...",
    "filter_original": "Filtrer tekst på opprinnelig språk",
    "filter_translation": "Filtrer etter oversatt tekst",
    "table": {
      "original": "Original",
      "language": "Språk",
      "url": "Oversatt URL",
      "action": "Handling",
      "edited": "Den opprinnelige oversettelsen er redigert"
    }
  }
}
